module.exports = __webpack_public_path__ + "media/components/page-header/static/snow-badge--dark-077fe00b07405d0a244e1294b9126342.svg";